import { PapiGallection } from '@wix/da-types-papi';
import { SCRAPS_FOLDER_ID } from '@wix/da-url';

export const putScrapsFolderLast = (a, b) =>
  b.folderId === SCRAPS_FOLDER_ID ? -1 : 0;

// convert flat folder array to a { folder, subfolders }[] array based on parentId attr
export const covertToFoldersWithSubfolders = (
  folders: PapiGallection[]
): { folder: PapiGallection; subfolders: PapiGallection[] }[] => {
  return (
    folders
      // attach subfolders
      .map(folder => ({
        folder,
        subfolders:
          folders.filter(
            potentialSubfolder =>
              potentialSubfolder.parentId === folder.folderId
          ) || [],
      }))
      // leave only top level folders
      .filter(({ folder }) => !folder.parentId)
  );
};
